import { Toolbar as MToolbar, ToolbarProps } from '@mui/material'

export const Toolbar: React.FC<ToolbarProps> = (props) => {
  return <MToolbar {...props} />
}
